import * as React from "react";
const SvgMenuClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      stroke="#3A2666"
      strokeWidth={2}
      d="m.728 1 16 15.665M.728 17l16-15.665"
    />
  </svg>
);
export default SvgMenuClose;
